import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import SalesReportsContent from '../SalesReportsContent';
import {
    setFromDate,
    setToDate,
    setSelectedBranch,
    applyFilters,
    fetchSalesReportData
} from '../../../store/slices/salesReportsSlice';

const SalesReports = () => {
    const dispatch = useDispatch();
    const storedBranchId = localStorage.getItem('branchid') || '';

    useEffect(() => {
        const toDate = new Date();
        const fromDate = new Date();
        fromDate.setDate(fromDate.getDate() - 30);
        dispatch(setFromDate(fromDate));
        dispatch(setToDate(toDate));
        dispatch(setSelectedBranch({ branch_id: storedBranchId || 'All', branch_name: 'Branch' }));
        // This view renders no filter bar/Apply button of its own, so nothing else would ever
        // snapshot fromDate/toDate/selectedBranch into applied* — and Branch Analysis/Cashier
        // Sales both fetch off the applied* values, not the live ones, so without this they'd
        // never load here no matter what.
        dispatch(applyFilters());
        dispatch(fetchSalesReportData({
            fromDate,
            toDate,
            branchId: storedBranchId || 'All'
        }));
    }, [dispatch, storedBranchId]);

    return <SalesReportsContent />;
};

export default SalesReports;
